module.exports = __webpack_public_path__ + "img/transport_BicycleBooking.b4b4f7c.png";